import styles from "../../styles/shared/connect-to-exchange/ConnectToExchangeButton.module.css";
import { LuPlus } from "react-icons/lu";
import { useDispatch, useSelector } from "react-redux";
import { openExchangeConnectionSettings } from "../../redux/exchange/actions";
import ExchangeConnectionSettingsMenu from "./ExchangeConnectionSettingsMenu";

function ConnectToExchangeButton({
  className,
  useDefaultStyle = true,
  style = {},
  title = "Connect to Exchanges",
  icon,
  targetExchange = "",
  onClick,
}) {
  const {
    ui: { openSideMenu },
  } = useSelector((state) => state);

  const dispatch = useDispatch();

  const clickHandler = (e) => {
    e.stopPropagation();

    if (onClick) {
      onClick();
    }
    dispatch(openExchangeConnectionSettings(targetExchange));
  };

  return (
    <>
      <div
        className={`${useDefaultStyle ? styles.defaultStyle : ""} ${className}`}
        style={style}
        onClick={clickHandler}
      >
        {icon || <LuPlus />}
        <span>{title}</span>
      </div>
      {/*{openSideMenu && <ExchangeConnectionSettingsMenu />}*/}
      <ExchangeConnectionSettingsMenu />
    </>
  );
}

export default ConnectToExchangeButton;
